
// define(
// 	'NVT.NewContactRegistration.NewContactRegistration'
// ,   [
// 		'NVT.NewContactRegistration.NewContactRegistration.View'
// 	]
// ,   function (
// 		NewContactRegistrationView
// 	)
// {
// 	'use strict';

// 	return  {
// 		mountToApp: function mountToApp (container)
// 		{
// 			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
// 			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
// 			// more documentation of the Extensibility API in
// 			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
// 			/** @type {LayoutComponent} */
// 			var LoginRegisterPage = container.getComponent('LoginRegisterPage');

// 			if (LoginRegisterPage)
// 			{
// 			  LoginRegisterPage.addChildView('Register.CustomFields', function ()
// 			  {
// 				return new NewContactRegistrationView
// 				({
// 					LoginRegisterPage: LoginRegisterPage
// 				})
// 			  });
// 			}


// 		}
// 	};
// });



define(
	'NVT.NewContactRegistration.NewContactRegistration'
	, [
		'NVT.NewContactRegistration.NewContactRegistration.View',
		'NVT.NewContactRegistration.NewContactCreation.View'
	]
	, function (
		NewContactRegistrationView,
		NewContactCreationView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				// using the 'Layout' component we add a new child view inside the 'Header' existing view 
				// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
				// more documentation of the Extensibility API in
				// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html

				/** @type {LayoutComponent} */
				var LoginRegisterPage = container.getComponent('LoginRegisterPage');

				if (LoginRegisterPage) {
					LoginRegisterPage.addChildView('Register.CustomFields', function () {
						if (SC.CONFIGURATION.NewContactRegistration.isnewcontactregistration === true) {
							return new NewContactCreationView
								({
									LoginRegisterPage: LoginRegisterPage
								})
						}
						else {
							return new NewContactRegistrationView
								({
									LoginRegisterPage: LoginRegisterPage
								})
						}

					});
				}


			}
		};
	});
